// extracted by mini-css-extract-plugin
module.exports = {"drawer":"NavigationDrawer_drawer_X7Ku7","group":"NavigationDrawer_group_2DSeT","icon":"NavigationDrawer_icon_3zIJl"};